import React from 'react';
import {
  List,
  ListItem,
  Accordion,
  Typography,
  AccordionBody,
  ListItemPrefix,
} from '@material-tailwind/react';
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import { FilePlus2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const MenuPcm = ({ LIST_ITEM_STYLES, handleMenu }) => {
  const [open, setOpen] = React.useState(0);

  const navigate = useNavigate();
  const handleNavigate = (route) => {
    navigate(route);
  };

  const handleOpen = (value) => {
    setOpen(open === value ? 0 : value);
  };
  return (
    <Accordion open={open === 3}>
      <ListItem
        selected={open === 3}
        data-selected={open === 3}
        onClick={() => handleOpen(3)}
        className={LIST_ITEM_STYLES}
      >
        <ListItemPrefix>
          <FilePlus2 color="white" className="h-5 w-5" />
        </ListItemPrefix>
        PCM
        <ChevronDownIcon
          strokeWidth={3}
          className={`ml-auto h-4 w-4 text-gray-500 transition-transform ${
            open === 3 ? 'rotate-180' : ''
          }`}
        />
      </ListItem>
      <AccordionBody className="py-1">
        <List className="p-0" onClick={handleMenu}>
          <ListItem
            className={`px-12 ${LIST_ITEM_STYLES}`}
            onClick={() => handleNavigate("/pcm/horas_extras")}
          >
            Horas Extras
          </ListItem>
          {/* <ListItem
            className={`px-12 ${LIST_ITEM_STYLES}`}
            onClick={() => handleNavigate('/cadastrar/categoria/')}
          >
            Categoria/Linha
          </ListItem>
          <ListItem
            className={`px-12 ${LIST_ITEM_STYLES}`}
            onClick={() => handleNavigate('/cadastrar/maquinario/')}
          >
            Maquinario
          </ListItem>
          <ListItem
            className={`px-12 ${LIST_ITEM_STYLES}`}
            onClick={() => handleNavigate('/cadastrar/equipamento/peca')}
          >
            Equipamento/Peças
          </ListItem> */}
        </List>
      </AccordionBody>
    </Accordion>
  );
};

export default MenuPcm;
